export const FIREBASE_CONFIG = {
	apiKey           : "AIzaSyAn_HrT70iyqUO-vjhG72fIdHkr8GONIes",
	authDomain       : "app-anticamente.firebaseapp.com",
	databaseURL      : "https://app-anticamente.firebaseio.com",
	projectId        : "app-anticamente",
	storageBucket    : "app-anticamente.appspot.com",
	messagingSenderId: "602665163972"
};


// WEBPACK FOOTER //
// ./src/providers/sms-auth/firebase.credentials.ts